import React from 'react';
import { DropdownMenu, MenuItem } from 'modules/header/components/Layout';
import { ISearchThreadsResult } from 'modules/threads/types';
import SearchItem from 'modules/header/components/SearchItem';

interface ISearchResults {
  searchResults: ISearchThreadsResult[];
  searchValue: string;
  setShowMenu: (showMenu: boolean) => void;
}

export const SearchResults: React.FC<ISearchResults> = ({
  searchResults,
  searchValue,
  setShowMenu,
}) => {
  return (
    <DropdownMenu>
      {searchResults.length ? (
        <>
          {searchResults.map((thread) => (
            <SearchItem
              key={thread.id}
              search={searchValue}
              {...thread}
              setShowMenu={setShowMenu}
            />
          ))}
        </>
      ) : (
        <MenuItem>threads not found</MenuItem>
      )}
    </DropdownMenu>
  );
};

export default SearchResults;
